import { Link } from "react-router-dom";
import { IceCreamCone, Phone, Mail, MapPin, Clock, Facebook } from "lucide-react";
import { SITE, NAV_LINKS } from "../data/site";

export const Footer = () => (
  <footer className="bg-blue-600 text-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-yellow-400">
            <IceCreamCone className="h-6 w-6 text-slate-900" aria-hidden="true" />
          </span>
          <span className="font-display text-lg font-semibold" data-testid="footer-business-name">{SITE.name}</span>
        </div>
        <p className="mt-4 text-sm font-semibold text-blue-100">"{SITE.motto}"</p>
        {SITE.facebook && (
          <a
            href={SITE.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ms. Jeanette's on Facebook"
            data-testid="footer-facebook-link"
            className="mt-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/15 transition-colors hover:bg-white/25 focus:outline-none focus:ring-4 focus:ring-yellow-300"
          >
            <Facebook className="h-5 w-5" aria-hidden="true" />
          </a>
        )}
      </div>

      <nav aria-label="Footer navigation">
        <h3 className="font-display text-base font-semibold text-yellow-300">Quick Links</h3>
        <ul className="mt-4 space-y-2">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-sm font-semibold text-blue-100 transition-colors hover:text-yellow-300 focus:outline-none focus:ring-4 focus:ring-yellow-300 rounded"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-display text-base font-semibold text-yellow-300">Visit Us</h3>
        <ul className="mt-4 space-y-3 text-sm font-semibold text-blue-100">
          <li>
            <a
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="flex items-start gap-2 rounded transition-colors hover:text-yellow-300 focus:outline-none focus:ring-4 focus:ring-yellow-300"
            >
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
              <span className="underline decoration-yellow-300/60 underline-offset-4">{SITE.address}</span>
            </a>
          </li>
          <li>
            <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors hover:text-yellow-300 focus:outline-none focus:ring-4 focus:ring-yellow-300 rounded">
              <Phone className="h-4 w-4 shrink-0" aria-hidden="true" />
              {SITE.phone}
            </a>
          </li>
          <li>
            <a href={SITE.emailHref} data-testid="footer-email-link" className="flex items-center gap-2 break-all transition-colors hover:text-yellow-300 focus:outline-none focus:ring-4 focus:ring-yellow-300 rounded">
              <Mail className="h-4 w-4 shrink-0" aria-hidden="true" />
              {SITE.email}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="flex items-center gap-2 font-display text-base font-semibold text-yellow-300">
          <Clock className="h-4 w-4" aria-hidden="true" /> Hours
        </h3>
        <ul className="mt-4 space-y-2 text-sm font-semibold text-blue-100" data-testid="footer-hours">
          {SITE.hours.map((h) => (
            <li key={h.days} className="flex justify-between gap-3">
              <span>{h.days}</span>
              <span className="text-right">{h.time}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/15 px-4 py-5 text-center text-xs font-semibold text-blue-100" data-testid="footer-copyright">
      © 2026 Ms. Jeanette's Shaved Ice Snowballs. All Rights Reserved.
    </div>
  </footer>
);
